import {action} from "typesafe-actions";
import {DashboardActionTypes} from "./types";
import {Dashboard} from "../../models/Dashboard";

export const fetchRequest = () => action(DashboardActionTypes.FETCH_REQUEST);
export const fetchSuccess = (data: Dashboard) => action(DashboardActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(DashboardActionTypes.FETCH_ERROR, [message]);
